import service from "@/store/services/sales-delivery-items-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  deliveryItem: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, deliveryItem) => {
    state.deliveryItem = deliveryItem;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((deliveryItem) => {
      commit("SET_RESOURCE", deliveryItem);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((deliveryItem) => {
      commit("SET_RESOURCE", deliveryItem);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((deliveryItem) => {
      commit("SET_RESOURCE", deliveryItem);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  deliveryItem: (state) => state.deliveryItem,
  url: (state) => state.url,
};

const deliveryItems = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default deliveryItems;
